import { render, staticRenderFns } from "./IndagineEpidemiologicaMalariaViewComponent.vue?vue&type=template&id=1e144d29"
import script from "./IndagineEpidemiologicaMalariaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMalariaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports